import alertCodeMessageDescriptors from "./alert-code-message-descriptors";

/**
 * Maps puaMerge warning/error codes to translation messages with dynamic data
 * @param {array} alertCodes - Array of puaMerge error codes
 * @returns {array} Array of mapped translation messages
 */
const mapCodesToMessages = (alertCodes = []) =>
  alertCodes.reduce((accumulator, currentCode) => {
    const mappedMessage = alertCodeMessageDescriptors[currentCode];

    if (mappedMessage) {
      accumulator.push(mappedMessage);
    }

    return accumulator;
  }, []);

export default mapCodesToMessages;
